(() => {
  if (window.KinakoCartProgressLoaded) return;
  window.KinakoCartProgressLoaded = true;

  const PROGRESS_SELECTOR = '[data-cart-progress]';

const CONFIG = {
  thresholdCents: 6000,
  giftProductId: 8890120700057,
  giftHandle: 'personalized-pet-photo-mug',
  giftTitle: 'Personalized Pet Photo Mug',
    giftPropertyName: '_isFreeGift',
    giftPropertyValue: 'true',
    sectionsToRefresh: [
      'cart-drawer',
      'cart-icon-bubble',
      'main-cart-items',
      'main-cart-footer',
    ],
  };

  let debounceTimer = null;
  let fetchPatched = false;
  let xhrPatched = false;
  let observerStarted = false;
  let internalCartRequest = false;
  let checkoutInProgress = false;
  let cachedGiftVariantId = null;

  const routesRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  function route(path) {
    return `${routesRoot}${String(path).replace(/^\//, '')}`;
  }

  function getSettings() {
    const block = document.querySelector(PROGRESS_SELECTOR);

    return {
      thresholdCents: Number(
        block?.dataset?.thresholdCents || CONFIG.thresholdCents
      ),
      giftProductId: CONFIG.giftProductId,
      giftHandle: CONFIG.giftHandle,
      giftTitle:
        block?.dataset?.freeGiftTitle || CONFIG.giftTitle,
    };
  }

  function getCurrency(cart) {
    if (cart && cart.currency) return cart.currency;

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }

    return 'USD';
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    })
      .format(Math.max(0, cents) / 100)
      .replace('.00', '');
  }

  async function fetchJson(url, options = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }

    return response.json();
  }

  async function fetchCart() {
    return fetchJson(route('/cart.js'), {
      method: 'GET',
    });
  }

  async function fetchGiftVariantId() {
    if (cachedGiftVariantId) {
      return cachedGiftVariantId;
    }

    const product = await fetchJson(route(`/products/${CONFIG.giftHandle}.js`), {
      method: 'GET',
    });

    const firstVariant = product.variants && product.variants[0];

    if (!firstVariant || !firstVariant.id) {
      throw new Error('Could not find the free mug variant.');
    }

    cachedGiftVariantId = Number(firstVariant.id);
    return cachedGiftVariantId;
  }

  function isManagedGiftLine(item) {
    if (!item) return false;

    const productMatch = Number(item.product_id) === Number(CONFIG.giftProductId);
    const handleMatch = item.handle === CONFIG.giftHandle;
    const variantMatch =
      cachedGiftVariantId &&
      Number(item.variant_id) === Number(cachedGiftVariantId);

    return Boolean(productMatch || handleMatch || variantMatch);
  }

  function getManagedGiftLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter((item) => isManagedGiftLine(item));
  }

  function getQualifyingSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce((total, item) => {
      if (isManagedGiftLine(item)) return total;

      return total + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function updateProgressUI(cart) {
    const blocks = Array.from(document.querySelectorAll(PROGRESS_SELECTOR));
    if (!blocks.length) return;

    const settings = getSettings();
    const subtotalCents = getQualifyingSubtotal(cart);
    const currency = getCurrency(cart);
    const unlocked = subtotalCents >= settings.thresholdCents;
    const remainingCents = Math.max(settings.thresholdCents - subtotalCents, 0);

    const progress = unlocked
      ? 100
      : Math.max(0, Math.min((subtotalCents / settings.thresholdCents) * 100, 100));

    const roundedProgress = Math.round(progress);

    blocks.forEach((block) => {
      const message =
        block.querySelector('[data-cart-progress-message]') ||
        block.querySelector('[data-cart-progress-text]') ||
        block.querySelector('.kp-cart-progress__message') ||
        block.querySelector('.kp-cart-progress__text');

      const percent =
        block.querySelector('[data-cart-progress-percent]') ||
        block.querySelector('.kp-cart-progress__percent');

      block.style.setProperty('--kp-progress', `${progress}%`);
      block.classList.toggle('kp-cart-progress--unlocked', unlocked);
      block.classList.toggle('is-unlocked', unlocked);

      if (message) {
        message.textContent = unlocked
          ? `🎉 You've unlocked a free ${settings.giftTitle}! It will be added when you check out.`
          : `You're ${formatMoney(remainingCents, currency)} away from a free ${settings.giftTitle}!`;
      }

      if (percent) {
        percent.textContent = `${roundedProgress}%`;
      }
    });
  }

  function injectFreeGiftCss() {
    if (document.getElementById('kinako-free-gift-cart-css')) return;

    const style = document.createElement('style');
    style.id = 'kinako-free-gift-cart-css';

    style.textContent = `
      .kp-managed-free-gift-line .quantity,
      .kp-managed-free-gift-line quantity-input,
      .kp-managed-free-gift-line .quantity-popover-container,
      .kp-managed-free-gift-line .cart-item__quantity,
      .kp-managed-free-gift-line .cart-item__quantity-wrapper,
      .kp-managed-free-gift-line cart-remove-button,
      .kp-managed-free-gift-line .cart-remove-button,
      .kp-managed-free-gift-line [data-cart-remove],
      .kp-managed-free-gift-line button[name="minus"],
      .kp-managed-free-gift-line button[name="plus"],
      .kp-managed-free-gift-line input[name="updates[]"] {
        display: none !important;
        pointer-events: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getClosestCartLine(element) {
    if (!element || !element.closest) return null;

    return element.closest(
      '.cart-item, tr.cart-item, li.cart-item, [id^="CartDrawer-Item-"], [id^="CartItem-"], [data-cart-item]'
    );
  }

  function lineLooksLikeMugGift(line) {
    if (!line) return false;

    const text = (line.textContent || '').toLowerCase();

    const hasMugTitle =
      text.includes('custom pet photo mug') ||
      text.includes(CONFIG.giftTitle.toLowerCase());

    const hasMugLink = Boolean(
      line.querySelector(`a[href*="/products/${CONFIG.giftHandle}"], a[href*="${CONFIG.giftHandle}"]`)
    );

    return Boolean(hasMugTitle || hasMugLink);
  }

  function markFreeGiftLinesInCart() {
    injectFreeGiftCss();

    const possibleCartLines = document.querySelectorAll(
      '.cart-item, tr.cart-item, li.cart-item, [id^="CartDrawer-Item-"], [id^="CartItem-"], [data-cart-item]'
    );

    possibleCartLines.forEach((line) => {
      if (lineLooksLikeMugGift(line)) {
        line.classList.add('kp-managed-free-gift-line');
      }
    });
  }

  async function changeLineQuantityByKey(lineKey, quantity) {
    if (!lineKey) return null;

    internalCartRequest = true;

    try {
      return await fetchJson(route('/cart/change.js'), {
        method: 'POST',
        body: JSON.stringify({
          id: String(lineKey),
          quantity: Number(quantity),
        }),
      });
    } catch (error) {
      console.warn('[Kinako cart progress] Could not change cart line. It may already be removed.', error);
      return null;
    } finally {
      internalCartRequest = false;
    }
  }

  async function addGiftLine() {
    const variantId = await fetchGiftVariantId();

    internalCartRequest = true;

    try {
      return await fetchJson(route('/cart/add.js'), {
        method: 'POST',
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                [CONFIG.giftPropertyName]: CONFIG.giftPropertyValue,
              },
            },
          ],
        }),
      });
    } finally {
      internalCartRequest = false;
    }
  }

  async function removeGiftLines(lines) {
    for (const line of lines) {
      if (line && line.key) {
        await changeLineQuantityByKey(line.key, 0);
      }
    }
  }

  async function refreshCartSections() {
    let sections;

    try {
      sections = await fetchJson(
        route(`/cart?sections=${CONFIG.sectionsToRefresh.join(',')}`),
        {
          method: 'GET',
        }
      );
    } catch (error) {
      console.warn('[Kinako cart progress] Could not refresh cart sections.', error);
      return;
    }

    CONFIG.sectionsToRefresh.forEach((sectionId) => {
      const html = sections[sectionId];
      if (!html) return;

      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

      const currentSection =
        document.getElementById(`shopify-section-${sectionId}`) ||
        document.getElementById(sectionId);

      const freshSection =
        parsedDocument.getElementById(`shopify-section-${sectionId}`) ||
        parsedDocument.getElementById(sectionId);

      if (currentSection && freshSection) {
        currentSection.innerHTML = freshSection.innerHTML;
        return;
      }

      if (sectionId === 'cart-drawer') {
        const currentDrawer = document.querySelector('cart-drawer');
        const freshDrawer = parsedDocument.querySelector('cart-drawer');

        if (currentDrawer && freshDrawer) {
          currentDrawer.innerHTML = freshDrawer.innerHTML;
          currentDrawer.classList.remove('is-empty');
        }

        return;
      }

      if (sectionId === 'cart-icon-bubble') {
        const currentBubble =
          document.getElementById('cart-icon-bubble') ||
          document.querySelector('[id*="cart-icon-bubble"]');

        const freshBubble =
          parsedDocument.getElementById('cart-icon-bubble') ||
          parsedDocument.querySelector('[id*="cart-icon-bubble"]');

        if (currentBubble && freshBubble) {
          currentBubble.innerHTML = freshBubble.innerHTML;
        }
      }
    });

    markFreeGiftLinesInCart();
  }

  async function cleanCartGiftOnly() {
    try {
      await fetchGiftVariantId();

      let cart = await fetchCart();
      const settings = getSettings();
      const qualifyingSubtotal = getQualifyingSubtotal(cart);
      const qualifies = qualifyingSubtotal >= settings.thresholdCents;
      const giftLines = getManagedGiftLines(cart);

      updateProgressUI(cart);
      markFreeGiftLinesInCart();

      let changed = false;

      if (!qualifies && giftLines.length > 0) {
        await removeGiftLines(giftLines);
        changed = true;
      }

      if (qualifies && giftLines.length > 1) {
        for (let index = 1; index < giftLines.length; index += 1) {
          await changeLineQuantityByKey(giftLines[index].key, 0);
          changed = true;
        }

        if (Number(giftLines[0].quantity) !== 1) {
          await changeLineQuantityByKey(giftLines[0].key, 1);
          changed = true;
        }
      }

      if (changed) {
        await refreshCartSections();
        cart = await fetchCart();
        updateProgressUI(cart);
        markFreeGiftLinesInCart();
      }
    } catch (error) {
      console.warn('[Kinako cart progress clean]', error);
    }
  }

  async function ensureGiftBeforeCheckout() {
    await fetchGiftVariantId();

    let cart = await fetchCart();
    const settings = getSettings();
    const qualifyingSubtotal = getQualifyingSubtotal(cart);
    const qualifies = qualifyingSubtotal >= settings.thresholdCents;
    let giftLines = getManagedGiftLines(cart);

    if (!qualifies) {
      if (giftLines.length > 0) {
        await removeGiftLines(giftLines);
      }

      return;
    }

    if (giftLines.length === 0) {
      await addGiftLine();
      cart = await fetchCart();
      giftLines = getManagedGiftLines(cart);
    }

    for (let index = 0; index < giftLines.length; index += 1) {
      const giftLine = giftLines[index];

      if (index === 0 && Number(giftLine.quantity) !== 1) {
        await changeLineQuantityByKey(giftLine.key, 1);
      }

      if (index > 0) {
        await changeLineQuantityByKey(giftLine.key, 0);
      }
    }
  }

  function queueClean(delay = 1500) {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(() => {
      cleanCartGiftOnly();
    }, delay);
  }

  function isCartMutationUrl(request) {
    const url =
      typeof request === 'string'
        ? request
        : request && request.url
          ? request.url
          : '';

    return (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );
  }

  function patchFetchForCartChanges() {
    if (fetchPatched || !window.fetch) return;

    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      try {
        if (!internalCartRequest && isCartMutationUrl(args[0])) {
          queueClean(1800);
        }
      } catch (error) {
        console.warn('[Kinako cart progress fetch patch]', error);
      }

      return response;
    };

    fetchPatched = true;
  }

  function patchXhrForCartChanges() {
    if (xhrPatched || !window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function patchedOpen(method, url, ...rest) {
      this._kinakoCartMutationUrl = url || '';
      return originalOpen.call(this, method, url, ...rest);
    };

    window.XMLHttpRequest.prototype.send = function patchedSend(...args) {
      this.addEventListener('loadend', () => {
        try {
          if (!internalCartRequest && isCartMutationUrl(this._kinakoCartMutationUrl)) {
            queueClean(1800);
          }
        } catch (error) {
          console.warn('[Kinako cart progress xhr patch]', error);
        }
      });

      return originalSend.apply(this, args);
    };

    xhrPatched = true;
  }

  function startCartObserver() {
    if (observerStarted || !window.MutationObserver || !document.body) return;

    const observer = new MutationObserver(() => {
      markFreeGiftLinesInCart();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    observerStarted = true;
  }

  function isCheckoutTarget(target) {
    if (!target || !target.closest) return false;

    return Boolean(
      target.closest('button[name="checkout"]') ||
      target.closest('input[name="checkout"]') ||
      target.closest('a[href="/checkout"]') ||
      target.closest('a[href*="/checkout"]') ||
      target.closest('[data-checkout-button]') ||
      target.closest('.cart__checkout-button')
    );
  }

  async function goToCheckout(event) {
    if (checkoutInProgress) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }

      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    checkoutInProgress = true;

    const checkoutButton =
      event && event.target && event.target.closest
        ? event.target.closest('button, input, a')
        : null;

    if (checkoutButton) {
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.classList.add('loading');

      if ('disabled' in checkoutButton) {
        checkoutButton.disabled = true;
      }
    }

    try {
      await ensureGiftBeforeCheckout();
      window.location.href = route('/checkout');
    } catch (error) {
      console.warn('[Kinako cart progress checkout gift]', error);
      window.location.href = route('/checkout');
    }
  }

  function bindCheckoutEvents() {
    document.addEventListener(
      'click',
      (event) => {
        if (isCheckoutTarget(event.target)) {
          goToCheckout(event);
          return false;
        }

        return true;
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;

        if (!form || !form.matches) return true;

        const isCartForm =
          form.matches('form[action="/cart"]') ||
          form.matches('form[action*="/cart"]') ||
          form.closest('cart-drawer');

        const hasCheckoutButton = Boolean(
          form.querySelector('button[name="checkout"], input[name="checkout"], .cart__checkout-button')
        );

        if (isCartForm && hasCheckoutButton) {
          goToCheckout(event);
          return false;
        }

        return true;
      },
      true
    );
  }

  function init() {
    patchFetchForCartChanges();
    patchXhrForCartChanges();
    startCartObserver();
    bindCheckoutEvents();

    markFreeGiftLinesInCart();
    queueClean(500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.KinakoCartProgress = {
    sync: cleanCartGiftOnly,
    addGiftBeforeCheckout: ensureGiftBeforeCheckout,
  };
})();